import { UploadAssetsStoreType } from "store/type";

export const initGlobalState: UploadAssetsStoreType = {
  MyFiles: [],
  MyFilesMeta: { total: 0, page: 1, limit: 10 },
  RecentFileCount: [],
  getMyFilesLoading: false,
  saveMyFilesLoading: false,
  getRecentFilesCountLoading: false,
  mainAssetDetail: {},
//   updateAssetTypeLoading: false,
  deleteAssetTypeLoading: false,
  mainAssetDetailLoading: false,
};

